import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const ProductCardPreview = forwardRef(({
  className, products, discount, hasImage, ...rest
}, ref) => {
  const classes = useStyles();
  const [product, setProduct] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    ref?.current?.addEventListener('change', () => {
      setPreviewImage(URL.createObjectURL(ref?.current?.files[0]));
    });
  }, []);

  useEffect(() => {
    setProduct(products?.find((p) => p?.id === discount?.product_id));
  }, [discount, products]);

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="product"
              src={previewImage || product?.primary_image}
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {product?.name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              variant="body1"
            >
              {product?.description}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              variant="body1"
            >
              {product?.price > 0 ? `COP $${product?.price}` : ''}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              variant="body1"
            >
              {product?.estimated_time}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

ProductCardPreview.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object,
  hasImage: PropTypes.bool,
  products: PropTypes.array,
  discount: PropTypes.shape({
    product_id: PropTypes.string,
  }),
};

ProductCardPreview.defaultProps = {
  className: '',
  product: {},
  hasImage: false,
  products: [],
  discount: {
    product_id: '',
  },
};

export default ProductCardPreview;
